import * as React from "react"

import { LoadingTable } from "@tenforce/toolbox-table-react"

import PlaceholderWidget from "../../../../common/grid/widgets/PlaceholderWidget"

interface Props extends React.HTMLAttributes<HTMLElement> {
    isLoading: boolean
    hasContent: boolean
    nothingFoundLabel: string
    arePlaceholdersWidgets?: boolean
}

const NavigationTab = ({
    isLoading,
    hasContent,
    children,
    nothingFoundLabel,
    arePlaceholdersWidgets,
    ...attrs
}: Props): JSX.Element => {
    let content = <>{children}</>

    if (isLoading) {
        content = arePlaceholdersWidgets ? (
            <div className="is-loading is-placeholder">
                <PlaceholderWidget color="bg-darker" />
                <PlaceholderWidget color="bg-darker" />
                <PlaceholderWidget color="bg-darker" />
            </div>
        ) : (
            <LoadingTable
                extraClasses="tw-my-2"
                id="navigationLoading"
                showFooter={false}
                showHeader={false}
            />
        )
    } else if (!hasContent) {
        content = (
            <div className="tw-m-3 is-inverted" id="navigationNothingFound">
                <div className="text-dimmed">
                    <p>{nothingFoundLabel}</p>
                </div>
            </div>
        )
    }

    return <div {...attrs}>{content}</div>
}

NavigationTab.defaultProps = {
    nothingFoundLabel: "Nothing found.",
    arePlaceholdersWidgets: false,
}

export default NavigationTab
